import type { Country } from '@seek/audience-zones';

export type CountryLowercase = Lowercase<Country>;

export const getTrackingCountryCode = (
  country: Country | undefined,
): CountryLowercase | undefined => {
  const countryLowercase = country ? country.toLowerCase() : undefined;
  return countryLowercase as CountryLowercase;
};
